import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M35.9 31.58C41.88 30.82 45.85 30.74 47.96 37.86C49.28 42.32 49 47.24 49.45 52.39C50.11 60.05 50.94 66.26 50.94 66.26C50.94 66.26 54.96 50.61 53.75 38.69C52.14 22.84 43.22 20.85 37.28 18.21C31.64 15.71 30.67 6.14996 30.67 6.14996C31 8.29996 29.51 11.93 29.51 11.93C30.17 7.79999 28.52 4 28.52 4C28.52 4 26.87 13.25 20.76 17.21C15.93 20.35 3.08998 21.35 1.43998 38.69C0.299976 50.62 4.24997 66.26 4.24997 66.26C4.24997 66.26 5.06996 60.05 5.73996 52.39C6.18996 47.24 5.90998 42.32 7.22998 37.86C9.33998 30.74 13.31 30.82 19.29 31.58C27.03 32.57 28.14 32.57 35.9 31.58Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M31.8099 9.12C31.8899 11.13 31.7499 13.16 31.3899 15.16C31.0399 17.16 30.4799 19.13 29.6099 21C29.1699 21.94 28.6199 22.82 28.1399 23.65C27.6699 24.51 27.2299 25.39 26.8899 26.31C26.5499 27.22 26.2599 28.17 26.1199 29.14C25.9599 30.11 25.9399 31.11 26.1999 32.08C25.3299 30.22 25.5799 28 26.1499 26.06C26.4199 25.06 26.8599 24.13 27.2999 23.21C27.7899 22.29 28.3099 21.47 28.6999 20.58C29.5399 18.82 30.1199 16.92 30.6199 15C31.1099 13.07 31.5099 11.11 31.8099 9.12Z"
        fill={outline}
      />
      <path
        d="M28.1799 7.95996C28.1799 7.95996 28.1799 15.23 25.2099 20.84C22.2399 26.45 20.4199 28.6 21.4099 31.9"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M32.6399 13.08C32.6399 13.08 32.0099 18.91 33.2999 23.65C34.7899 29.1 33.9599 32.07 33.9599 32.07"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M24.8801 16.55C24.3301 17.84 23.6601 19.08 22.9201 20.27C22.2001 21.48 21.3001 22.5801 20.5701 23.7501C19.8301 24.9201 19.1801 26.1501 18.7501 27.4401C18.3201 28.7101 18.0901 30.11 18.5801 31.22L17.6501 31.59C17.1101 30.03 17.5301 28.49 18.0501 27.17C18.5901 25.83 19.3401 24.61 20.1601 23.46C20.9801 22.3 21.9301 21.2801 22.7201 20.1201C23.5101 18.9901 24.2501 17.8 24.8801 16.55Z"
        fill={outline}
      />
      <path
        d="M19.5901 21.34C18.7501 22.21 17.8801 23.04 16.9601 23.84C16.0501 24.64 15.0501 25.35 14.1701 26.13C13.3001 26.92 12.5401 27.8 12.1101 28.82C11.6601 29.83 11.5301 30.95 11.5801 32.06H10.0801C10.1501 30.77 10.4401 29.45 11.1001 28.31C11.7401 27.16 12.7001 26.26 13.6901 25.54C14.6901 24.81 15.7401 24.23 16.7201 23.53C17.7201 22.85 18.6701 22.12 19.5901 21.34Z"
        fill={outline}
      />
      <path
        d="M34.95 19.03C35.94 21.14 37.3 23.07 38.95 24.66C39.8 25.48 40.6199 26.34 41.3399 27.34C42.0399 28.32 42.6999 29.5401 42.6299 31.0001L41.14 30.85C41.3 29.94 40.94 28.9101 40.39 27.9501C39.84 26.9801 39.1399 26.0601 38.3999 25.1801C36.8699 23.3401 35.71 21.24 34.95 19.03Z"
        fill={outline}
      />
      <path
        d="M41.0601 23.8201C42.3601 24.8101 43.4701 26.07 44.2601 27.54C44.6701 28.27 44.9401 29.08 45.1201 29.92C45.3101 30.76 45.2801 31.6401 45.1801 32.5001L44.2001 32.3C44.3501 31.56 44.4701 30.79 44.3701 30.02C44.2901 29.25 44.12 28.4801 43.8 27.7501C43.21 26.2801 42.2501 24.9301 41.0601 23.8201Z"
        fill={outline}
      />
      <path
        d="M13.1499 22.33C11.9299 23 10.8399 23.89 9.93992 24.93C9.03992 25.97 8.29992 27.15 7.84992 28.43C7.69992 28.74 7.6399 29.08 7.5499 29.4C7.4599 29.73 7.3599 30.05 7.3299 30.39L7.17991 31.39L7.15992 32.4C7.09992 33.07 7.24992 33.75 7.28992 34.42C7.38992 35.09 7.55993 35.75 7.69993 36.41L6.72992 36.64C6.62992 35.93 6.48991 35.23 6.42991 34.52C6.42991 33.8 6.31993 33.09 6.41993 32.38C6.45993 30.95 6.85991 29.54 7.39991 28.24C7.94991 26.93 8.7899 25.76 9.7699 24.76C10.7499 23.76 11.8999 22.92 13.1499 22.33Z"
        fill={outline}
      />
    </g>
  )
}
